// eslint-disable-next-line no-restricted-imports
import { ClassNames } from '@emotion/react';
import { VerificationInput } from '@iheartjane/menu';
import type { ControllerRenderProps } from 'react-hook-form';

export const MultifactorVerificationInput = ({
  error,
  field,
  atCheckout,
}: {
  atCheckout?: boolean;
  error?: unknown | null;
  field: ControllerRenderProps;
}) => (
  <ClassNames>
    {({ css, theme }) => (
      <VerificationInput
        autoFocus
        value={field.value}
        onChange={(value: string) => field.onChange(value)}
        placeholder=""
        validChars="0-9"
        inputProps={{ inputMode: 'numeric' }}
        classNames={{
          character: css({
            width: 48,
            fontSize: '24px',
            fontFamily: theme.components.Typography.fonts.branded.fontFamily,
            color: theme.colors.grays.black,
            backgroundColor: theme.colors.grays.white,
            borderRadius: theme.borderRadius.xs,
            border: '0 none',
            outline: error
              ? `1px solid ${theme.colors.system.negative.main}`
              : `1px solid ${theme.colors.grays.light}`,
          }),
          characterSelected: css({
            outline: error
              ? `2px solid ${theme.colors.system.negative.main}`
              : `2px solid ${theme.colors.primary.main}`,
          }),
          container: css({
            display: 'flex',
            gap: atCheckout ? 11 : 8,
            height: 48,
            width: '100% !important',
          }),
        }}
      />
    )}
  </ClassNames>
);
